import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createDemandSuppressionMaster,
  listDemandSuppressionMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要抑制計画マスタ 新規登録 mutation hook。
 * onSuccess で listDemandSuppressionMasters を invalidate してテーブルを最新化する。
 */
export function useCreateDemandSuppressionMaster(): InvalidatingMutationResultFor<
  typeof createDemandSuppressionMaster
> {
  return useInvalidatingMutation(createDemandSuppressionMaster, [
    createConnectQueryKey({
      schema: listDemandSuppressionMasters,
      cardinality: 'finite',
    }),
  ])
}
